import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import pdf from "../../assets/HsuResume2025.pdf";

import { getAllProjectData } from "../../data/util.js";

import "./Work-Page.css";

export default function WorkPage() {
  const navigate = useNavigate();

  const projectData = getAllProjectData();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="header-green top-padding cursor selected-work">
        Selected Work
      </div>
      <div className="workpage-text">
        <p>Find a selection of my work below, and click to learn more.</p>
        <p>
          {" "}
          View my resume{" "}
          <a className="resumehere" href={pdf} target="_blank" rel="noreferrer">
            here
          </a>
          .
        </p>
      </div>

      <div className="allshows">
        {projectData.map((project, i) => {
          return (
            <div
              className="show-images"
              onClick={() => navigate(`/work/${project.projectUrl}`)}
            >
              <div className="all-shows-title font-special cursor">
                {project.title}
              </div>
              <img
                key={`selected-work-photo-${i}`}
                src={project.enhancedCoverImage.url}
                alt={project.enhancedCoverImage.alt}
                className="showimage cursor"
              />

              {project.photographer && (
                <div className="show-images">
                  show photography by{" "}
                  <a
                    href={project.photographer.photographerUrl}
                    target="_blank"
                    className="link"
                    rel="noreferrer"
                  >
                    {project.photographer.name}
                  </a>
                </div>
              )}

              <hr className="line" />
            </div>
          );
        })}
      </div>
    </>
  );
}
